<template>
  <div>
    <PageLoadAnimation />
  </div>
</template>